































import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';

import DashboardMainPanel from '@/libs/dashboard/components/DashboardMainPanel.vue';
import DashboardWorkTaskColumn from '@/libs/dashboard/components/DashboardWorkTaskColumn.vue';
import DashboardClientEvaluationColumn from '@/libs/dashboard/components/DashboardClientEvaluationColumn.vue';
import DashboardNewClientsColumn from '@/libs/dashboard/components/DashboardNewClientsColumn.vue';
import DashboardNewWorkTasksColumn from '@/libs/dashboard/components/DashboardNewWorkTasksColumn.vue';

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import {AccountTypeEnum, TenantUserModel} from '@/libs/Api';

@Component({
    components: {
        DashboardMainPanel, DashboardWorkTaskColumn, DashboardClientEvaluationColumn, DashboardNewClientsColumn, DashboardNewWorkTasksColumn, Swiper, SwiperSlide
    },
    directives: {
      swiper: directive
    }
})
export default class Dashboard extends Page {

    swiperOptions = {};
    tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;

    @Prop() tenantId!: string;

	mounted() {
		if (this.tenantUser.accountType == AccountTypeEnum.Worker || this.tenantUser.accountType == AccountTypeEnum.Volunteer) {
			this.$router.push({ name: "WorkTasks" });
		}
	}
    
}
